import { TDeviceType } from '@cian/ui-kit';
import { ESiteType } from './siteType';

export function getSiteType(deviceType: TDeviceType) {
  return deviceType === 'phone' ? ESiteType.mobile : ESiteType[deviceType];
}
